import React from "react";
import { ForwardArrowGlyph } from "./style";

const ForwardArrow = () => <ForwardArrowGlyph aria-hidden="true" />;

export default ForwardArrow;
